import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_project_job,
  get_project_job,
  update_project_job,
} from "../../../../Controllers/Projects/Jobs";
import forms from "../../../../Data/Forms/Projects/Jobs/forms";
import headers from "../../../../Data/Forms/Projects/Jobs/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { convert_to_file } from "../../../../Controllers/Global";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Projectjobemployeestable from "../../../../Data/Forms/Projects/Jobs/employees";
import Projectjobitemstable from "../../../../Data/Forms/Projects/Jobs/items";

const ProjectsjobsForm = () => {
  const { project, id } = useParams();
  let navigate = useNavigate();

  headers.navigate.path[0].path = `/app/projects/jobs/${project}`;

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const itemFocus = useRef([]);
  const employeeFocus = useRef([]);

  const [itemDetails, setItemDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      quantity: "",
      purchase_price: "",
      purchase_options: "",
      tax: 0,
      tax_amount: 0,
      total: 0,
    },
  ]);

  const [itemTotals, setItemTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    total: "0.000",
  });

  const [employeeDetails, setEmployeeDetails] = useState([
    {
      id: "",
      description: null,
      role: "",
      hours: "",
      cost: "",
      total: 0,
    },
  ]);
  const [employeeTotals, setEmployeeTotals] = useState({
    total: "0.000",
  });

  const itemDetailssValidation = (tabledata) => {
    let params = {};

    if (itemDetails?.length > 0) {
      let total = itemDetails?.length;
      let count = 0;

      let validated = [];
      itemDetails?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            itemFocus.current[`description${i}`].current.focus();
          } else if (!v?.quantity) {
            document.getElementById(
              `quantity${i}`
            ).textContent = `Quantity is required`;
            itemFocus.current[`quantity${i}`].current.focus();
          } else if (!v?.purchase_price) {
            document.getElementById(
              `purchase_price${i}`
            ).textContent = `Purchase price is required`;
            itemFocus.current[`purchase_price${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;
            document.getElementById(`purchase_price${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const employeesDetailsValidation = (tabledata) => {
    let params = {};

    if (employeeDetails?.length > 0) {
      let total = employeeDetails?.length;
      let count = 0;

      let validated = [];
      employeeDetails?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            employeeFocus.current[`description${i}`].current.focus();
          } else if (!v?.hours) {
            document.getElementById(
              `hours${i}`
            ).textContent = `Hours is required`;
            employeeFocus.current[`hours${i}`].current.focus();
          } else if (!v?.charges) {
            document.getElementById(
              `charges${i}`
            ).textContent = `Charges is required`;
            employeeFocus.current[`charges${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`hours${i}`).textContent = ``;
            document.getElementById(`charges${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }
    } else {
      toast?.error("Details not found");
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      const tableItemdetailsvalidation = itemDetailssValidation(data?.data);

      if (tableItemdetailsvalidation?.status) {
        const tableEmployeedetailsvalidation = employeesDetailsValidation(
          data?.data
        );

        if (tableEmployeedetailsvalidation?.status) {
          console.log(
            {
              ...data?.data,
              itemdetails: tableItemdetailsvalidation?.data?.details,
              employeedetails: tableEmployeedetailsvalidation?.data?.details,
            },
            "data?.data"
          );

          setButtonLoader(true);

          const job = id
            ? await update_project_job({
                ...data?.data,
                id: id,
                project: project,
                itemdetails: tableItemdetailsvalidation?.data?.details,
                employeedetails: tableEmployeedetailsvalidation?.data?.details,
              })
            : await create_project_job({
                ...data?.data,
                project: project,
                itemdetails: tableItemdetailsvalidation?.data?.details,
                employeedetails: tableEmployeedetailsvalidation?.data?.details,
              });

          if (job?.status) {
            if (id) {
              navigate(-1);
            }

            toast?.success(job?.message);
            setButtonLoader(false);
          } else {
            toast?.error(job?.message);
            setButtonLoader(false);
          }
        }
      }
    }
  };

  const handleData = async (job) => {
    let image = job?.image ? job?.image : "";
    let file = await convert_to_file(image);
    let name = job?.name ? job?.name : "";
    let description = job?.description ? job?.description : "";
    let number = job?.number ? job?.number : "";
    let status = job?.status ? job?.status : 0;

    values[0].options[0].form.value = file;
    values[0].options[1].form.value = name;
    values[0].options[2].form.value = description;
    values[0].options[3].form.value = number;

    values[1].options[0].form.value = status;

    let item_data = [];
    job?.item_details?.map((value, index) => {
      item_data?.push({
        id: value?._id,
        description: value?.description?._id,
        name: value?.description?.name,
        unit: value?.description?.unit?.name,
        quantity: value?.quantity ? value?.quantity : 0,
        purchase_price: value?.purchase_price ? value?.purchase_price : 0,
        tax: value?.tax ? value?.tax : 0,
        total: value?.total ? value?.total : 0,
      });
    });
    itemTotals.subtotal = job?.item_subtotal;
    itemTotals.taxamount = job?.item_taxamount;
    itemTotals.total = job?.item_total;

    let employee_data = [];
    job?.employee_details?.map((value, index) => {
      employee_data?.push({
        id: value?._id,
        description: value?.description?._id,
        name: value?.description?.name,
        role: value?.description?.role?.name,
        hours: value?.hours ? value?.hours : 0,
        charges: value?.charges ? value?.charges : 0,
        total: value?.total,
      });
    });
    employeeTotals.total = job?.employee_total;

    setLoader(false);
    setValues([...values]);
    setItemDetails(item_data);
    setEmployeeDetails(employee_data);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const job = await get_project_job(data);
      if (job?.status) {
        handleData(job?.data);
      } else {
        toast?.error(job?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={2} title={"Estimate Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Projectjobitemstable
                itemDetails={itemDetails}
                setItemDetails={setItemDetails}
                itemTotals={itemTotals}
                setItemTotals={setItemTotals}
                ref={itemFocus}
              />
            </Formdata>
          </Bodycomponent>
          <Bodycomponent>
            <Titlecomponent index={3} title={"Estimate Employees"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Projectjobemployeestable
                employeeDetails={employeeDetails}
                setEmployeeDetails={setEmployeeDetails}
                employeeTotals={employeeTotals}
                setEmployeeTotals={setEmployeeTotals}
                ref={employeeFocus}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default ProjectsjobsForm;
